<template>
  <div>
    <transition-group name="list">
      <div v-for="file in displayedFiles" v-bind:key="file.type" class="form-group">
        <File :file="file" :isDeletable="isModificationEnabled" @delete="$emit('delete', file)" />
      </div>
    </transition-group>
  </div>
</template>

<style scoped>
  .list-enter-from,
  .list-enter-active,
  .list-leave-active {
    max-height: 60px;
    transition: 0.5s ease;
    overflow: hidden;
  }
  .list-leave-to {
    max-height: 0;
    border-width: 0;
    padding-top: 0;
    padding-bottom: 0;
    margin-top: 0;
    margin-bottom: 0;
    opacity: 0;
  }
</style>

<script>
  import File from "@/components/File";
  import { getFileType } from "@/components/SongEditForm";

  export default {
    components: {
      File
    },
    props: {
      files: {
        type: Array,
        default: () => []
      },
      fileUploads: {
        type: Array,
        default: () => []
      },
      isModificationEnabled: {
        type: Boolean,
        default: () => true
      }
    },
    computed: {
      displayedFiles() {
        let files = [];
        let fileTypes = []
        this.files.forEach(f => {
          let type = getFileType(f)
          fileTypes.push(type);
          let fileUploadMatches = this.fileUploads.filter(f => f.progress > 0 && f.error == '' && f.success == false && type == getFileType(f));
          if (fileUploadMatches.length > 0)
            files.push(fileUploadMatches[0]);
          else
            files.push(f);
        });
        return files.concat(this.fileUploads.filter(f => f.progress > 0 && f.success == false && fileTypes.indexOf(getFileType(f)) == -1));
      }
    },
  }
</script>